import { getZrmLeaseInfo } from '@zg-rentals/clickstream';
import { trackEvent } from '../index';

import type { ZrmClickstreamLease } from '@zg-rentals/clickstream';

const EVENT_IDS = {
  SELECT_LEASE_PROPERTY: '6727',
} as const;

export const SELECT_LEASE_PROPERTY_EVENT_ID = EVENT_IDS.SELECT_LEASE_PROPERTY;

// https://dataportal.zillowgroup.net/event-registry/6727
export const emitSelectLeasePropertyEvent = (lease?: ZrmClickstreamLease) =>
  trackEvent.lease({
    envelope: {
      event_template_id: '447',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.SELECT_LEASE_PROPERTY,
      event_type_version_id: '2',
    },
    clickstream_trigger: {
      trigger_location_nm: 'properties_leases',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'property_card_click',
    },
    semantic: {
      semantic_event_nm: 'select_lease_property',
      topic_tag_txt: [],
    },
    ...getZrmLeaseInfo(lease),
  });
